import * as React from "react";
import {cx} from "emotion";

import "./single-mode.scss";

import {cs}                     from "@Common/react/chain-services";
import {consumeContext}         from "@Common/react/context";
import {Load2}                  from "@Common/react/load2";
import {isIe, isEdge}           from "@Common/ui-components/debug/is-ie-edge-or-firefox";
import {formatMoneyBackOptions} from "@Common/ui-components/language/format-money";

import {TemplateSvgThumbnail} from "@Xpresso/routes/common/components/template-svg-thumbnail/template-svg-thumbnail";

import {filteredOptions} from "../../../../../../../common/filtered-options";

export const SingleMode = ({templateBacks, currentlySelected, currentlyViewing, onSelect, onChangeView}) => cs(
    consumeContext("themeScheme"),
    consumeContext("svgThumbnailsCache"),
    ["back", (_, next) => next(templateBacks?.find(back => back.id === currentlyViewing))],
    ["svgCodeLoad", ({back, svgThumbnailsCache: {loadUrl}}, next) => Load2({
        next,
        fetch: async () => back?.image.endsWith(".svg") ? loadUrl(back.image) : null,
    })],
    ({back, svgCodeLoad: {value: svgCode}, themeScheme}) => (
        <div className={cx("mode-list mode-single-6sk", {"ie": isIe(), "edge": isEdge()})}>
            {templateBacks?.length > 1 && (
                <button
                    className="left-button"
                    style={{backgroundColor: themeScheme.xpresso.menuBackgroundColor, color: themeScheme.xpresso.headerColor}}
                    onClick={(e) => {
                        // e.preventDefault();
                        e.stopPropagation();
                        const newIndex = templateBacks?.indexOf(back) - 1;
                        templateBacks && onChangeView(templateBacks[newIndex < 0 ? templateBacks.length - 1 : newIndex]?.id);
                    }}
                    xd-qa-type="Button"
                    xd-qa-name="Left"
                >
                    <i className="fa fa-chevron-left"/>
                </button>
            )}
            <div
                className="template-back"
            >
                {svgCode ? (
                    <TemplateSvgThumbnail svgCode={svgCode}/>
                ) : (
                    <img src={back?.image} alt="Back Thumbnail"/>
                )}
                {currentlyViewing === currentlySelected && templateBacks?.length > 1 && (
                    <div className="check">
                        <i className="fa fa-check"/>
                    </div>
                )}
                <div
                    className="footer"
                >
                    <div
                        className="text"
                        data-tip={back?.name}
                    >
                        <div className="back-name">
                            {back?.name}
                        </div>
                        {back?.option?.length > 0 && (
                            <div className="upgrade-option">
                                {formatMoneyBackOptions(back.option.reduce((cnt, option) => {return cnt + option.unitprice;}, 0))}
                                {" "}
                                {" - "}
                                {filteredOptions(back.option)}
                            </div>
                        )}
                    </div>
                    {templateBacks?.length > 1 && (
                        <button
                            onClick={(e) => {
                                // e.preventDefault();
                                e.stopPropagation();
                                onSelect(back?.id);
                            }}
                            xd-qa-type="Button"
                            xd-qa-name="SELECT THIS TEMPLATE"
                        >
                            SELECT THIS TEMPLATE
                        </button>
                    )}
                </div>
            </div>
            {templateBacks?.length > 1 && (
                <button
                    className="right-button"
                    style={{backgroundColor: themeScheme.xpresso.menuBackgroundColor, color: themeScheme.xpresso.headerColor}}
                    onClick={(e) => {
                        // e.preventDefault();
                        e.stopPropagation();
                        if (templateBacks) {
                            const newIndex = templateBacks.indexOf(back) + 1;
                            onChangeView(templateBacks[newIndex >= templateBacks.length ? 0 : newIndex]?.id);
                        }
                    }}
                    xd-qa-type="Button"
                    xd-qa-name="Right"
                >
                    <i className="fa fa-chevron-right"/>
                </button>
            )}
        </div>
    ),
);
